<template>
  <div class="log-search">
    <div class="query-form">
        <div class="search-keyword">
          <span>搜索内容：</span>
          <a-input placeholder="操作人、操作对象" v-model="tableParams.blurry" allowClear style="margin: 0 15px 0 0;width: 200px;" @pressEnter="blurrySearch"></a-input>
          <span>模块：</span>
          <a-select style="width:220px; margin-right: 15px;" v-model="tableParams.moduleName" mode="multiple">
            <a-select-option v-for ="item in moduleList" :value="item" :key="item">{{item}}</a-select-option>
          </a-select>
          <span>操作类型：</span>
            <a-select v-model="tableParams.type" mode="multiple" style="width:150px;margin-right: 15px;">
              <a-select-option v-for ="item in typeList" :value="item" :key="item">{{item}}</a-select-option>
            </a-select> 
            <span>操作时间：</span>
            <a-range-picker v-model="doDate" style="width:230px;" />
            <div>
              <span v-show="roleId == 'admin'">企业名称：</span>
              <a-select v-show="roleId == 'admin'" v-model="deptId" mode="multiple"  style="width:180px;margin-right: 20px;">
                <a-select-option v-for ="item in companyList" :value="`${item.name}+${item.id}`" :key="item.id">{{item.name}}</a-select-option>
              </a-select> 
              <a-button style="margin: 10px 0" type="primary" icon="search"  @click="blurrySearch">搜索</a-button>
            </div>
        </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="dataList"
        :pagination="pagination"
        @change="pagChange"
        @expandRowByClick="true"
        :rowKey="record => record.id"
        :loading="tableLoading">
        <!-- 企业名称 -->
        <template slot="dept" slot-scope="dept">
          <p v-if="dept">{{dept.name}}</p>
        </template>
        <template slot="createTime"  slot-scope="createTime">
            <p>{{createTime | formatDate}}</p>
        </template>
        <template slot="user"  slot-scope="user">
            <p>{{user.username}} {{user.realname}}</p>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>

import { getLogList, getLogType, getModuleList, getCompanyList } from '@/api/log'
import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index'

const align = 'center'
export default {
  name: 'logSerach',
  components: {},
  data() {
    return {
      formItemLayout:{
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 15
        },
      },
      columns:[
        {
          title: "模块",
          dataIndex: 'moduleName',
          align,
          width: 200
        },
        {
          title: "操作对象",
          dataIndex: 'entityName',
          align,
        },
        {
          title: "操作类型",
          dataIndex: 'type',
          align,
        },
        // {
        //   title: "详细内容",
        //   dataIndex: 'content',
        //   scopedSlots: { customRender: 'content' },
        //   align,
        //   width: 200,
        // },
        {
          title: "操作人",
          dataIndex: 'user',
          scopedSlots: { customRender: 'user' },
          align,
        },
        {
          title: "操作时间",
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align,
          width: 200,
        },
      ],
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '50', '100', '200', '500'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      roleId: '',
      tableLoading: false,//表格加载动画
      form: this.$form.createForm(this),
      roles: [],
      isFilter: false,
      dataList: [],
      moduleList: [],
      typeList: [],
      searchVisible: false,
      doDate: [],
      companyList: [],
      deptId: [],
      tableParams:{
          page: 1,
          size: 10,
          deptId: [],
          blurry: '',
          moduleName: [],
          type: []
      },
    }
  },
  mounted() {
    this.roleId = this.$store.state.user.roles;
    if(this.roleId == 'admin'){   //  不是企业 展示
        let newTitle = {
          title: "企业名称",
          dataIndex: 'dept',
          scopedSlots: { customRender: 'dept' },
          align,
          width:240,
        }
        this.columns.splice(1,0,newTitle)
      }else{ // 是企业不展示
      this.columns.map((item,index)=>{
          if(item.title == '企业名称'){
            this.columns.splice(index,1)
          }
        })
      }
    let userId = this.$store.state.user.user.id;
    let userMsg = this.$store.state.user.user;
    this.getlist();
    this.getLogType();
    this.getModuleList();
    this.getCompanyList();
  },
  methods: {
    getLogType() {
      getLogType()
        .then(res => {
          this.typeList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getModuleList() {
      getModuleList()
        .then(res => {
          this.moduleList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getCompanyList() {
      getCompanyList()
        .then(res => {
          this.companyList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    // 搜索
    blurrySearch(){
      this.pagination.current = 1;
      if(this.doDate.length > 0){
        this.tableParams.startCreateDate = Date.parse(formatDate(new Date(this.doDate[0]._d),"yyyy/MM/dd"))
        this.tableParams.endCreateDate = Date.parse(formatDate(new Date(this.doDate[1]._d),"yyyy/MM/dd"))+(23*3600*1000)+(3599*1000)
      }
      if(this.deptId.length > 0){
        var deptId = this.deptId.map(item=>{
          return item.split('+')[1]
        })
        this.tableParams.deptId = deptId
      }else {
        this.tableParams.deptId = []
      }
      this.getlist()
    },
    pagChange(pagination){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getlist()
    },
    getlist(){
      this.tableLoading = true
      this.tableParams.page = this.pagination.current - 1
      this.tableParams.size=this.pagination.pageSize
      getLogList(this.tableParams).then(res=>{
        this.tableLoading = false
        let data = res.content;
        data.map((item,index)=> {
          item.No = index+1
        })
        this.dataList = data
        this.pagination.total = res.totalElements
        this.pagination.current = res.page
        this.pagination.pageSize = res.size
      }).catch(error=>{
        console.log(error)
        this.tableLoading = false
      })
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
.filter-area {
    height: 44px;
    line-height: 44px;
    background-color: #fff;
    text-align: right;
    margin-top: 10px;
}
.table {
  background: #fff;
  z-index: 1;
}
.ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
.query-form {
  padding: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
    &::after{
      content:'';
      clear:both;
      display: block;
    }
    .search-keyword {
    }
    .advanced-search{
      margin: 8px 20px  8px 0;
      .form-container{
        width: 500px;
      }
    }
  }
  .standard-detail {
      .content {
          .info-list {
              margin-bottom: 10px;
              font-size: 12px;
              .sum-span:first-child {
                  margin-right: 100px;
              }
          }
          .important {
              color:crimson;
          }
      }
  }
</style>

